export function downloadFile(base64, filename) {
  // const temp = `${encodeURIComponent(base64)}`;
  const download = document.createElement('a');
  download.href = base64;
  download.download = filename;
  document.body.appendChild(download);
  download.click();
  document.body.removeChild(download);
}
